import { Link, Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { AuthLayout } from './LoginPage';
import { useOrganizations } from '../data/hooks';
import { Button, ErrorState, Loading } from '../components/ui';
import { ROLE_LABEL } from '../lib/roles';
import { portalClubIds } from '../app/layouts';

export function StartRedirect() {
  const { session } = useAuth();
  if (!session) return null;
  if (session.platformRole === 'platform_admin' || session.platformRole === 'support') return <Navigate to="/platform/clubs" replace />;
  const portal = portalClubIds(session);
  if (portal.length === 1) return <Navigate to={`/c/${portal[0]!}`} replace />;
  return <Navigate to="/clubs" replace />;
}

export function ClubPickerPage() {
  const { session, signOut } = useAuth();
  const orgs = useOrganizations();
  const portal = portalClubIds(session).map((orgId) => {
    const m = session?.memberships.find((x) => x.organization_id === orgId && (x.role === 'club_admin' || x.role === 'group_manager'));
    return { organization_id: orgId, label: m ? ROLE_LABEL[m.role as 'club_admin' | 'group_manager'] : ROLE_LABEL.installer };
  });
  return (
    <AuthLayout>
      <h2>Kies een club</h2>
      <p className="muted" style={{ marginBottom: 20 }}>
        Je bent beheerder bij meer dan één club.
      </p>
      {orgs.isLoading && <Loading />}
      {orgs.error && <ErrorState error={orgs.error} />}
      {portal.length === 0 && !orgs.isLoading ? (
        <div className="alert">
          Je account heeft nog geen beheerrol bij een club. Gebruik de Antreja-app om deuren te openen, of vraag je clubbeheerder om
          een uitnodiging.
        </div>
      ) : (
        <ul className="club-list">
          {portal.map((m) => {
            const org = orgs.data?.find((o) => o.id === m.organization_id);
            return (
              <li key={m.organization_id}>
                <Link to={`/c/${m.organization_id}`}>
                  <span>
                    <strong>{org?.name ?? '…'}</strong>
                    <span className="muted small">{m.label}</span>
                  </span>
                  <span aria-hidden="true">›</span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
      {portal.length === 1 && <Navigate to={`/c/${portal[0]!.organization_id}`} replace />}
      <Button variant="ghost" onClick={() => void signOut()} style={{ marginTop: 20 }}>
        Uitloggen
      </Button>
    </AuthLayout>
  );
}
